import {useSelector} from "react-redux";

export default function useGeoBlocked() {
    return useSelector(state => !!state.user.geoBlocked);
}
